import {Spinner, Flex} from '/app/src/component'
import React from 'react';

const LoadingScreen = () => (
    <Flex h='100%' w='100%'>
        <Spinner/>
    </Flex>
)

export default LoadingScreen



// WEBPACK FOOTER //
// ./src/component/Modal/PaymentModal/LoadingScreen.js